'use strict';

module.exports = function (darc) {
  var WriteOp = require('./../WriteOp');

  darc.addOperation({
    name: 'empty',
    args: [],
    description: '',
    inputs: 'T[]',
    singular: true,
    extends: WriteOp,
    bubble: {
      update: function update(msg) {
        msg.deltas = {
          $save: []
        };
      }
    }
  });
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9vcHMvZW1wdHkuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsImRhcmMiLCJXcml0ZU9wIiwicmVxdWlyZSIsImFkZE9wZXJhdGlvbiIsIm5hbWUiLCJhcmdzIiwiZGVzY3JpcHRpb24iLCJpbnB1dHMiLCJzaW5ndWxhciIsImV4dGVuZHMiLCJidWJibGUiLCJ1cGRhdGUiLCJtc2ciLCJkZWx0YXMiLCIkc2F2ZSJdLCJtYXBwaW5ncyI6IkFBQUE7O0FBRUFBLE9BQU9DLE9BQVAsR0FBaUIsVUFBVUMsSUFBVixFQUFpQjtBQUVqQyxNQUFNQyxVQUFVQyxRQUFTLGNBQVQsQ0FBaEI7O0FBRUFGLE9BQUtHLFlBQUwsQ0FBbUI7QUFFbEJDLFVBQU0sT0FGWTtBQUdsQkMsVUFBTSxFQUhZO0FBSWxCQyxpQkFBYSxFQUpLO0FBS2xCQyxZQUFRLEtBTFU7QUFNbEJDLGNBQVUsSUFOUTtBQU9sQkMsYUFBU1IsT0FQUztBQVNsQlMsWUFBUTtBQUVQQyxjQUFRLGdCQUFVQyxHQUFWLEVBQWdCO0FBRXZCQSxZQUFJQyxNQUFKLEdBQWE7QUFDWkMsaUJBQU87QUFESyxTQUFiO0FBSUE7QUFSTTtBQVRVLEdBQW5CO0FBdUJBLENBM0JEIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKCBkYXJjICkge1xuXG5cdGNvbnN0IFdyaXRlT3AgPSByZXF1aXJlKCAnLi8uLi9Xcml0ZU9wJyApO1xuXG5cdGRhcmMuYWRkT3BlcmF0aW9uKCB7XG5cblx0XHRuYW1lOiAnZW1wdHknLFxuXHRcdGFyZ3M6IFtdLFxuXHRcdGRlc2NyaXB0aW9uOiAnJyxcblx0XHRpbnB1dHM6ICdUW10nLFxuXHRcdHNpbmd1bGFyOiB0cnVlLFxuXHRcdGV4dGVuZHM6IFdyaXRlT3AsXG5cblx0XHRidWJibGU6IHtcblxuXHRcdFx0dXBkYXRlOiBmdW5jdGlvbiggbXNnICkge1xuXG5cdFx0XHRcdG1zZy5kZWx0YXMgPSB7XG5cdFx0XHRcdFx0JHNhdmU6IFtdXG5cdFx0XHRcdH07XG5cblx0XHRcdH1cblxuXHRcdH1cblxuXHR9ICk7XG5cbn07XG4iXX0=